var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1092 7.89063L7.89258 12.1073C7.35091 11.5656 7.01758 10.824 7.01758 9.99896C7.01758 8.34896 8.35091 7.01562 10.0009 7.01562C10.8259 7.01562 11.5676 7.34896 12.1092 7.89063Z",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8499 4.80937C13.3915 3.70937 11.7249 3.10938 9.99987 3.10938C7.0582 3.10938 4.31654 4.84271 2.4082 7.84271C1.6582 9.01771 1.6582 10.9927 2.4082 12.1677C3.06654 13.201 3.8332 14.0927 4.66654 14.8094",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01758 16.276C7.96758 16.676 8.97591 16.8927 10.0009 16.8927C12.9426 16.8927 15.6842 15.1594 17.5926 12.1594C18.3426 10.9844 18.3426 9.00937 17.5926 7.83437C17.3176 7.40104 17.0176 6.99271 16.7092 6.60938",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9242 10.582C12.7076 11.757 11.7492 12.7154 10.5742 12.932",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89102 12.1094L1.66602 18.3344",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3324 1.66797L12.1074 7.89297",
    stroke: "#1E1531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.3c626f92b05d652cc8419ffcdda868ec.svg";
export { ForwardRef as ReactComponent };